<template>
	<div class="numberBox">
		<div class="numberFrame marb25">
			<i class="iconfont iconvisImageCenter visNumber"></i>
			<div class="inlin">
				<numberGrow class="visFigure" v-if="destroy.flag" :value="reportCountList.TotalHospitalCount"></numberGrow>
				<span class="fz14"> 家</span><br />
				<span class="fz12">被质控影像中心</span>
			</div>
		</div>
		<div class="numberFrame marb25">
			<i class="iconfont iconvisReport visNumber"></i>
			<div class="inlin textl">
				<numberGrow class="visFigure" v-if="destroy.flag" :value="reportCountList.TotalReportCount"></numberGrow>
				<span class="fz14"> 份</span><br />
				<span class="fz12">被质控报告总数</span>
			</div>
		</div>
		<div class="numberFrame">
			<i class="iconfont iconvisDoctor visNumber"></i>
			<div class="inlin textl">
				<numberGrow class="visFigure" v-if="destroy.flag" :value="reportCountList.TotalFirstAproverCount"></numberGrow>
				<span class="fz14"> 人</span><br />
				<span class="fz12">被质控医生人数</span>
			</div>
		</div>
		<div class="numberFrame">
			<i class="iconfont iconvisTechnician visNumber"></i>
			<div class="inlin">
				<numberGrow class="visFigure" v-if="destroy.flag" :value="reportCountList.TotalTechnicianCount"></numberGrow>
				<span class="fz14"> 人</span><br />
				<span class="fz12">被质控技师人数</span>
			</div>
		</div>
	</div>
</template>
<script>
	import numberGrow from '../../components/tool/numberGrow'
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		components: {
			numberGrow,
		},
		data() {
			return {
			
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['visPieColorList']),
			...Vuex.mapState('supervisor', ['destroy']),
			...Vuex.mapState('visualization', ['reportCountList'])
		},

		methods: {
			// ...Vuex.mapActions('visualization', ['']),

		}

	}
</script>

<style>
</style>
